// 获取屏幕可视宽度，并设置html标签的font-size。

import { getBasicPx } from './index'
let resizeCallback = () => {
  let html = document.getElementsByTagName('html')[0]
  html.style.fontSize = getBasicPx() + 'px'
}

// 注册浏览器缩放的事件。
window.addEventListener('resize', resizeCallback, false)

// 在程序启动就设置html标签的font-size。
resizeCallback()
